import React, { Dispatch, SetStateAction } from 'react';

interface TicketSelectedType{

    account_key_client: number;
    agent_id: number;
    app: string;
    assing_to: string;
    base_name: string;
    chat_number: string;
    date_assignment: string;
    date_init: string;
    date_last_message: string;
    date_last_message_client: string;
    first_message_agent: string;
    id: string;
    label_ticket: string;
    name_client: string;
    sub_account: string;
    time_with_out_activity: string;
    _status_ticket: string;
}

interface MessageType {
    id:                 number;
    ticketID:           string;
    date:               Date;
    message:            string;
    sendBy:             string;
    type:               string;
    lng:                null;
    lat:                null;
    nameSend:           string;
    akc:                number;
    app:                string;
    caption:            string;
    chat:               string;
    idApp:              string;
    user_id:            null;
    key_account_client: number;
    duration:           null;
    status_call:        string;
    standard_formated:  boolean;
}

interface FollowUpTicketsContextType{
    ticketSelected: TicketSelectedType,
    setTicketSelected:Dispatch<SetStateAction<TicketSelectedType>>
   
    newMessage: MessageType,
    setNewMessage:Dispatch<SetStateAction<MessageType>>


}
export const FollowUpTicketsContext = React.createContext<FollowUpTicketsContextType>(null)